import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M9.75 16.75H4.118a1.75 1.75 0 0 1-1.565-2.533l5.44-10.881c.626-1.25 2.392-1.3 3.085-.086l3.429 6H20.5c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75h-9A1.75 1.75 0 0 1 9.75 20v-3.25ZM9.335 4.007a.25.25 0 0 1 .44-.013L12.78 9.25H11.5A1.75 1.75 0 0 0 9.75 11v4.25H4.118a.25.25 0 0 1-.224-.362L9.335 4.007Zm6.029 6.743H20.5a.25.25 0 0 1 .25.25v9a.25.25 0 0 1-.25.25h-9a.25.25 0 0 1-.25-.25v-3.25h4.527c1.344 0 2.186-1.452 1.52-2.618l-1.933-3.382Zm-1.728 0 2.358 4.126a.25.25 0 0 1-.217.374H11.25V11a.25.25 0 0 1 .25-.25h2.136Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  c
];
function n(r, d) {
  return e(), o("svg", l, [...a]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
